(function () {
    'use strict';

    angular
        .module('tikonApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate($resource) {

        var activateByKey = function (login, key) {

            var url = "api/activate/" + login + "/" + key;
            return $resource(url, {}, {
                    'get': {method: 'GET', isArray: false}
                }
            );

        }
        var sendActivationCode = function (login) {
            var url = "api/activate/sendActivationCodeFromPanel/" + login;
            return $resource(url, {}, {
                    'get': {method: 'GET', isArray: false}
                }
            );

        }
        var regenerateActivationKey = function (login) {
            var url = "api/activate/regenerate_key/" + login;
            return $resource(url, {}, {
                    'get': {method: 'GET', isArray: false}
                }
            );

        }

        var sendActivationCodeByVerificationType = function (login, verificationType) {
            var url = "api/activate/sendActivationCodeFromPanel-byVerificationType/" + login + '/' + verificationType;
            return $resource(url, {}, {
                    'get': {method: 'GET', isArray: false}
                }
            );

        }

        return {
            activateByKey: activateByKey,
            regenerateActivationKey: regenerateActivationKey,
            sendActivationCode: sendActivationCode
        };

        //var service = $resource('api/activate/userid/', {}, {
        //    'get': { method: 'GET', params: {}, isArray: false}
        //});
        //
        //return service;

    }
})();
